import { NgModule } from '@angular/core';
import { AdministradorLogsisComponent } from './administradores/administrador-logsis/administrador-logsis.component';
import { RecuperarPasswordComponent } from './logins/pass/recuperar-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { MenubarModule } from 'primeng/menubar';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { ToolbarModule } from 'primeng/toolbar';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';

import { ComponentsModule } from '../components/components.module';
import { PagesUiRoutingModule } from './pages-ui-routing.module';
import { MainavbarComponent } from '../components/mainavbar/mainavbar.component';
import { UsuarioComponent } from './usuarios/usuario/usuario.component';
import { SignupComponent } from './logins/signup/signup.component';
import { SigninComponent } from './logins/signin/signin.component';
import { MedicoComponent } from './medicos/medico/medico.component';
import { EnfermeraComponent } from './enfermeras/enfermera/enfermera.component';
import { SupervisorComponent } from './supervisores/supervisor/supervisor.component';
import { AdministradorComponent } from './administradores/administrador/administrador.component';
import { MedicoCasosclinicosComponent } from './medicos/medico-casosclinicos/medico-casosclinicos.component';
import { AdministradorCasosclinicosComponent } from './administradores/administrador-casosclinicos/administrador-casosclinicos.component';
import { AdministradorCasoclinicoUpdateComponent } from './administradores/administrador-casoclinico-update/administrador-casoclinico-update.component';
import { AdministradorProductosComponent } from './administradores/administrador-productos/administrador-productos.component';
import { AdministradorMedicosComponent } from './administradores/administrador-medicos/administrador-medicos.component';
import { AdministradorEnfermerasComponent } from './administradores/administrador-enfermeras/administrador-enfermeras.component';
import { AdministradorSupervisoresComponent } from './administradores/administrador-supervisores/administrador-supervisores.component';
import { MedicoProductosComponent } from './medicos/medico-productos/medico-productos.component';
import { MedicoCasoclinicoNuevoComponent } from './medicos/medico-casoclinico-nuevo/medico-casoclinico-nuevo.component';
import { AdministradorHospitalesComponent } from './administradores/administrador-hospitales/administrador-hospitales.component';
import { AdministradorHospitalNuevoComponent } from './administradores/administrador-hospital-nuevo/administrador-hospital-nuevo.component';
import { AdministradorInstitucionNuevoComponent } from './administradores/administrador-institucion-nuevo/administrador-institucion-nuevo.component';
import { AdministradorInstitucionesComponent } from './administradores/administrador-instituciones/administrador-instituciones.component';
import { AdministradorCatalogoComponent } from './administradores/administrador-catalogo/administrador-catalogo.component';
import { AdministradorUsuariosComponent } from './administradores/administrador-usuarios/administrador-usuarios.component';
import { AdministradorUsuarioNuevoComponent } from './administradores/administrador-usuario-nuevo/administrador-usuario-nuevo.component';
import { AdministradorUsuarioActualizarComponent } from './administradores/administrador-usuario-actualizar/administrador-usuario-actualizar.component';
import { MedicoRegistrarNuevoComponent } from './medicos/medico-registrar-nuevo/medico-registrar-nuevo.component';
import { EnfermeraRegistrarNuevoComponent } from './enfermeras/enfermera-registrar-nuevo/enfermera-registrar-nuevo.component';
import { SupervisorRegistrarNuevoComponent } from './supervisores/supervisor-registrar-nuevo/supervisor-registrar-nuevo.component';
import { AdministradorCasoclinicoComponent } from './administradores/administrador-casoclinico/administrador-casoclinico.component';
import { AdministradorMedicoComponent } from './administradores/administrador-medico/administrador-medico.component';
import { AdministradorInformacionInicialComponent } from './administradores/administrador-informacion-inicial/administrador-informacion-inicial.component';
import { AdministradorEnfermeraComponent } from './administradores/administrador-enfermera/administrador-enfermera.component';
import { AdministradorSupervisorComponent } from './administradores/administrador-supervisor/administrador-supervisor.component';
import { MedicoCasoclinicoComponent } from './medicos/medico-casoclinico/medico-casoclinico.component';
import { FileUpload } from 'primeng/fileupload';
import { FileUploadMinimalistaComponent } from '../components/file-upload-minimalista/file-upload-minimalista.component';
import { MedicoSaldoComponent } from './medicos/medico-saldo/medico-saldo.component';
import { MedicoCanjesComponent } from './medicos/medico-canjes/medico-canjes.component';
import { MedicoCanjeComponent } from './medicos/medico-canje/medico-canje.component';
import { EnfermeraCasosclinicosComponent } from './enfermeras/enfermera-casosclinicos/enfermera-casosclinicos.component';
import { EnfermeraProductosComponent } from './enfermeras/enfermera-productos/enfermera-productos.component';
import { EnfermeraSaldoComponent } from './enfermeras/enfermera-saldo/enfermera-saldo.component';
import { EnfermeraCanjesComponent } from './enfermeras/enfermera-canjes/enfermera-canjes.component';
import { EnfermeraCanjeComponent } from './enfermeras/enfermera-canje/enfermera-canje.component';
import { SupervisorEnfermerasComponent } from './supervisores/supervisor-enfermeras/supervisor-enfermeras.component';
import { SupervisorCasosclinicosComponent } from './supervisores/supervisor-casosclinicos/supervisor-casosclinicos.component';
import { SupervisorPendientesAsignarComponent } from './supervisores/supervisor-pendientes-asignar/supervisor-pendientes-asignar.component';
import { AdministradorProductosUploadBatchComponent } from './administradores/administrador-productos-upload-batch/administrador-productos-upload-batch.component';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';
import { AdministradorMedicosSaldosGeneralComponent } from './administradores/administrador-medicos-saldos-general/administrador-medicos-saldos-general.component';
import { AdministradorEnfermerasSaldosGeneralComponent } from './administradores/administrador-enfermeras-saldos-general/administrador-enfermeras-saldos-general.component';
import { SupervisorEnfermeraComponent } from './supervisores/supervisor-enfermera/supervisor-enfermera.component';
import { DiagnosticosComponent } from './catalogos/diagnosticos/diagnosticos.component';
import { DiagnosticoComponent } from './catalogos/diagnostico/diagnostico.component';
import { AntibioticosComponent } from './catalogos/antibioticos/antibioticos.component';
import { AntibioticoComponent } from './catalogos/antibiotico/antibiotico.component';
import { EspecialidadesComponent } from './catalogos/especialidades/especialidades.component';
import { EspecialidadComponent } from './catalogos/especialidad/especialidad.component';
import { PuestosComponent } from './catalogos/puestos/puestos.component';
import { PuestoComponent } from './catalogos/puesto/puesto.component';
import { AccionesComponent } from './catalogos/acciones/acciones.component';
import { AccionComponent } from './catalogos/accion/accion.component';
import { AdministradorNotificacionesCanjeEnfermerasComponent } from './administradores/administrador-notificaciones-canje-enfermeras/administrador-notificaciones-canje-enfermeras.component';
import { AdministradorNotificacionesCanjeMedicosComponent } from './administradores/administrador-notificaciones-canje-medicos/administrador-notificaciones-canje-medicos.component';
import { EnfermeraCanjeDetalleComponent } from './enfermeras/enfermera-canje-detalle/enfermera-canje-detalle.component';
import { MedicoCanjeDetalleComponent } from './medicos/medico-canje-detalle/medico-canje-detalle.component';
import { AdministradorDistribuidorNuevoComponent } from './administradores/administrador-distribuidor-nuevo/administrador-distribuidor-nuevo.component';
import { AdministradorDistribuidoresComponent } from './administradores/administrador-distribuidores/administrador-distribuidores.component';
import { AdministradorProductoComponent } from './administradores/administrador-producto/administrador-producto.component';
import { SupervisorCasoclinicoComponent } from './supervisores/supervisor-casoclinico/supervisor-casoclinico.component';
import { PuntosComponent } from './catalogos/puntos/puntos.component';
import { PuntoComponent } from './catalogos/punto/punto.component';
import { MedicoRedimirListComponent } from './medicos/medico-redimir-list/medico-redimir-list.component';
import { MedicoRedimirComponent } from './medicos/medico-redimir/medico-redimir.component';
import { MedicoRedimirDetalleComponent } from './medicos/medico-redimir-detalle/medico-redimir-detalle.component';
import { AdministradorInformeCanjesMedicosComponent } from './administradores/administrador-informe-canjes-medicos/administrador-informe-canjes-medicos.component';
import { SupervisorCanjeComponent } from './supervisores/supervisor-canje/supervisor-canje.component';
import { SupervisorCanjeDetalleComponent } from './supervisores/supervisor-canje-detalle/supervisor-canje-detalle.component';
import { SupervisorCanjesComponent } from './supervisores/supervisor-canjes/supervisor-canjes.component';
@NgModule({
  declarations: [
    AdministradorLogsisComponent,
    RecuperarPasswordComponent,
    UsuarioComponent,
    SignupComponent,
    SigninComponent,
    MedicoComponent,
    EnfermeraComponent,
    SupervisorComponent,
    AdministradorComponent,
    MedicoCasosclinicosComponent,
    AdministradorCasoclinicoUpdateComponent,
    AdministradorCasosclinicosComponent,
    MainavbarComponent,
    AdministradorProductosComponent,
    AdministradorProductoComponent,
    AdministradorMedicosComponent,
    AdministradorEnfermerasComponent,
    AdministradorSupervisoresComponent,
    MedicoProductosComponent,
    MedicoCasoclinicoNuevoComponent,
    AdministradorHospitalesComponent,
    AdministradorHospitalNuevoComponent,
    AdministradorInstitucionNuevoComponent,
    AdministradorInstitucionesComponent,
    AdministradorCatalogoComponent,
    AdministradorUsuariosComponent,
    AdministradorUsuarioNuevoComponent,
    AdministradorUsuarioActualizarComponent,
    MedicoRegistrarNuevoComponent,
    EnfermeraRegistrarNuevoComponent,
    SupervisorRegistrarNuevoComponent,
    AdministradorCasoclinicoComponent,
    AdministradorMedicoComponent,
    AdministradorInformacionInicialComponent,
    AdministradorEnfermeraComponent,
    AdministradorSupervisorComponent,
    MedicoCasoclinicoComponent,
    FileUploadMinimalistaComponent,
    FileUploadComponent,
    MedicoSaldoComponent,
    MedicoCanjesComponent,
    MedicoCanjeComponent,
    EnfermeraCasosclinicosComponent,
    EnfermeraProductosComponent,
    EnfermeraSaldoComponent,
    EnfermeraCanjesComponent,
    EnfermeraCanjeComponent,
    SupervisorEnfermerasComponent,
    SupervisorCasosclinicosComponent,
    SupervisorPendientesAsignarComponent,
    AdministradorProductosUploadBatchComponent,
    AdministradorMedicosSaldosGeneralComponent,
    AdministradorEnfermerasSaldosGeneralComponent,
    SupervisorEnfermeraComponent,
    DiagnosticosComponent,
    DiagnosticoComponent,
    AntibioticosComponent,
    AntibioticoComponent,
    EspecialidadesComponent,
    EspecialidadComponent,
    PuestosComponent,
    PuestoComponent,
    AccionesComponent,
    AccionComponent,
    AdministradorNotificacionesCanjeEnfermerasComponent,
    AdministradorNotificacionesCanjeMedicosComponent,
    EnfermeraCanjeDetalleComponent,
    MedicoCanjeDetalleComponent,
    AdministradorDistribuidorNuevoComponent,
    AdministradorDistribuidoresComponent,
    SupervisorCasoclinicoComponent,
    PuntosComponent,
    PuntoComponent,
    MedicoRedimirListComponent,
    MedicoRedimirComponent,
    MedicoRedimirDetalleComponent,
    AdministradorInformeCanjesMedicosComponent,
    SupervisorCanjeComponent,
    SupervisorCanjeDetalleComponent,
    SupervisorCanjesComponent
  ],
  imports: [
    ComponentsModule,
    CommonModule,
    PagesUiRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    CardModule,
    TableModule,
    ButtonModule,
    TabViewModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    InputTextareaModule,
    MultiSelectModule,
    FileUploadModule,
    MenubarModule,
    PaginatorModule,
    PanelModule,
    DividerModule,
    AccordionModule,
    ToolbarModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    DialogModule,
    InputSwitchModule
  ],

})
export class PagesUiModule { }
